module.exports = __webpack_public_path__ + "assets/img/Yoobic-Landing-Page-+-Website.fd9bfd73.jpg";